import client from './api-client';

export const getConfiguracionForm97 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form97: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConsultaHonorarios= async(query) => {
    try {
        
        const response = await client.get(`honorarios?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                consultaHonorarios: response.data.object,
                query:query
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getCompanias = async(query) => {
    try {
        
        const response = await client.getImplicado(`companias?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                companias: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getConceptos = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetDocumento = async(query) => {
    try {
        const response = await client.verDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGestionHonorarios = async(body) => {
    try {
        const response = await client.post('honorarios', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}